import { TypeSaisieKpi } from "../utils/type-saisie-kpi";
import { TypeReferentielDonneeAnalyse } from "./typeReferentielDonneeAnalyse";
import { UniteReferentielDonneeAnalyse } from "./uniteReferentielDonneeAnalyse";

export class ReferentielDonneeAnalyse {
  referentielDonneeAnalyseId: number;
  typeReferentielDonneeAnalyseId: number;
  uniteRefrentielDonneeAnalyseId: number;
  nom: string;
  //uniteReferentielDonneeAnalyse: UniteReferentielDonneeAnalyse;
  //typeReferentielDonneeAnalyse: TypeReferentielDonneeAnalyse;
  nomTypeReferentiel: string;
  nomUniteReferentiel: string;
  valeurNominal: number;
  valeurMin: number;
  valeurMax: number;
  type: string;
  description: string;
  calculMode: string;
  typeSaisieKpi?: TypeSaisieKpi
  displayUnit: string;
}
